import React from 'react';
import { Box, Spinner } from '@amzn/awsui-components-react';
import { useCrossClusterConnectionsQuery } from './hooks/useCrossClusterConnectionsQuery';
import { IndexReplicationTable } from './IndexReplicationTable';

interface CrossClusterInsightsTabProps {
  domainIdentifier: string;
}

const CrossClusterInsightsTab = (props: CrossClusterInsightsTabProps) => {
  const { loading, data, error } = useCrossClusterConnectionsQuery({
    domainIdentifier: props.domainIdentifier,
    includeReplicationStats: true,
  });

  // Index-level replication depends only on follower_stats. The resolver returns
  // followerStats: null when that call failed, so null here means "unavailable".
  const followerStats = data?.crossClusterConnections?.followerStats;

  if (loading) {
    return (
      <Box textAlign="center" padding="m">
        <Spinner size="normal" /> Loading index-level replication...
      </Box>
    );
  }

  if (error || !followerStats) {
    return (
      <Box textAlign="center" padding="m" color="text-status-error">
        Unable to fetch replication stats for this domain.
      </Box>
    );
  }

  return <IndexReplicationTable followerStats={followerStats} />;
};

export { CrossClusterInsightsTab };
